import { useEffect } from 'react';
import { api } from '@/api/apiClient';
import { storeOfflineItem, prepareOfflineAccess } from '@/lib/offlineStore';
import { syncEquipmentReports } from './reportQueue';

export default function EquipmentSync({ user }) {
  useEffect(() => {
    if (!user || user.impersonating) return;
    let stopped = false;
    const owner = String(user.id || user._id);
    const update = async () => {
      if (stopped || localStorage.getItem('sep-offline-owner') !== owner) return;
      try {
        const config = await api.request('GET', '/api/equipment-reports/config', null, { 'X-SEP-Background': 'offline' });
        if (stopped) return;
        await storeOfflineItem({ key: 'equipment-profile', kind: 'equipment-profile', name: 'Equipment reporting', owner,
          user: { id: owner, full_name: user.full_name, preferred_name: user.preferred_name }, config });
        if (config.mode === 'builtin') await prepareOfflineAccess();
      } catch { /* A cached configuration can still be used offline. */ }
      await syncEquipmentReports().catch(() => {});
    };
    void update();
    const timer = setInterval(update, 60000);
    window.addEventListener('online', update);
    return () => { stopped = true; clearInterval(timer); window.removeEventListener('online', update); };
  }, [user?.id, user?._id, user?.impersonating]);
  return null;
}
